/**
 * Volume/tiered pricing helper — mirrors the backend `resolve_unit_price`.
 * Returns the per-unit price for a quantity given a flat base price and
 * optional tiers. Falls back to base price when there are no tiers or the
 * quantity matches none (full backward compatibility with flat-price items).
 */
export function resolveUnitPrice(basePrice, tiers, qty) {
  const q = Math.max(1, parseInt(qty, 10) || 1);
  if (Array.isArray(tiers) && tiers.length) {
    for (const t of tiers) {
      const mn = t.min_qty ?? 1;
      const mx = t.max_qty ?? null;
      if (q >= mn && (mx === null || mx === undefined || q <= mx)) {
        return Number(t.unit_price);
      }
    }
  }
  return Number(basePrice);
}

/** True when the product has any volume tier below the base price. */
export function hasVolumePricing(basePrice, tiers) {
  return Array.isArray(tiers) && tiers.some((t) => Number(t.unit_price) < Number(basePrice));
}

/** Human label for a tier's quantity range, e.g. "1", "2–4", "5+". */
export function tierRangeLabel(t) {
  const mn = t.min_qty ?? 1;
  const mx = t.max_qty ?? null;
  if (mx === null || mx === undefined) return `${mn}+`;
  if (mn === mx) return `${mn}`;
  return `${mn}–${mx}`;
}
